import "./Home_Section.scss";
import { Btn } from "../Header_Utils/header_utils";
import BgSlider from "./BgSlider";


const HomeSection = () => {
  return (
    <div className="home_section">
      <BgSlider/>
      <div className="home_details">
        <h1>Empowering African Youth Through Agriculture</h1>
        <p>
          Join AFRIYOFA in transforming lives across East and West Africa. We
          equip young farmers with skills, technology, and resources to build
          sustainable agricultural enterprises and thriving communities.
        </p>
        <div>
          <Btn title="Get Involved" pathway="/contact" id="white-bg" />
        </div>
      </div>
    </div>
  );
};

export default HomeSection;
